var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { key: _vm.vehicle_stock_id, attrs: { id: "single-vehicle-stock" } },
    [
      !_vm.vehicle_stock_id
        ? _c("div", { staticClass: "stock-wrapper" }, [_vm._m(0)])
        : _vm.loading
        ? _c("div", { staticClass: "stock-wrapper" }, [_vm._m(1)])
        : _c(
            "div",
            { staticClass: "stock-wrapper" },
            [
              _c("div", { staticClass: "container-fluid full-width" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _vm.vehicleNextPrevCounterText !== ""
                      ? _c(
                          "div",
                          { attrs: { id: "vehicle-stock-next-prev" } },
                          [
                            _c("div", { staticClass: "container-fluid" }, [
                              _vm.currentNextPrev &&
                              _vm.currentNextPrev.back_to_all
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "btn back-to-all-btn",
                                      attrs: {
                                        href: _vm.currentNextPrev.back_to_all
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    Back to all\n                                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "next-prev" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "prev",
                                    attrs: { href: "#!" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.handleVehicleNextPrev(false)
                                      }
                                    }
                                  },
                                  [_vm._v("Prev")]
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.vehicleNextPrevCounterText))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "next",
                                    attrs: { href: "#!" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.handleVehicleNextPrev(true)
                                      }
                                    }
                                  },
                                  [_vm._v("Next")]
                                )
                              ])
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "search-result-top" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-md-6 col-12" }, [
                          _c("h2", [
                            _vm._v(
                              "Stock - " +
                                _vm._s(_vm.vehicleStockData.year) +
                                " " +
                                _vm._s(_vm.vehicleStockData.make) +
                                " " +
                                _vm._s(_vm.vehicleStockData.model)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-md-6 col-12 d-flex justify-content-end"
                          },
                          [
                            _vm.$userCan("delete_stock")
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "link text-danger",
                                    attrs: { href: "#!" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.deleteVehicleStock.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Delete")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "link",
                                attrs: { href: _vm.printPath, target: "_blank" }
                              },
                              [_vm._v("Print")]
                            ),
                            _vm._v(" "),
                            _vm.$userIsAdmin()
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "link",
                                    attrs: { href: _vm.editPath }
                                  },
                                  [_vm._v("Edit")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.currentNextPrev &&
                            _vm.currentNextPrev.back_to_all
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "link",
                                    attrs: {
                                      href: _vm.currentNextPrev.back_to_all
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Back to list\n                                    "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-md-12",
                          attrs: { id: "bid-history" }
                        },
                        [
                          _c(
                            "table",
                            {
                              staticClass: "bid-history table table-responsive"
                            },
                            [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [_vm._v("Day")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("ID")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Make")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Model/Grade")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Chassis")]),
                                  _vm._v(" "),
                                  _vm.$userIsAdmin()
                                    ? _c("th", [
                                        _vm._v("CO2 (indication only)")
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Year")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Kms")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Colour")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("CC")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Trans")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("F")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Dr")]),
                                  _vm._v(" "),
                                  _c("th", [_vm._v("Cnd")]),
                                  _vm._v(" "),
                                  _vm.$userIsAdmin()
                                    ? _c("th", [_vm._v("Price")])
                                    : _vm._e()
                                ])
                              ]),
                              _vm._v(" "),
                              _c("tbody", [
                                _c("tr", [
                                  _c(
                                    "td",
                                    { staticClass: "date" },
                                    [
                                      _vm.vehicleStockData.sold_date
                                        ? [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm.getDate(
                                                    _vm.vehicleStockData
                                                      .sold_date
                                                  )
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "td",
                                    { staticClass: "id-bid" },
                                    [
                                      _vm.vehicleStockData.stock_id
                                        ? [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm.vehicleStockData.stock_id
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        : [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm.vehicleStockData
                                                    .green_tree_sync_id
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "make" }, [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.vehicleStockData.make) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "model" }, [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.vehicleStockData.model) +
                                        " / " +
                                        _vm._s(_vm.vehicleStockData.grade) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.vehicleStockData.chassis) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.$userIsAdmin()
                                    ? _c("td", [
                                        _vm.vehicleStockData.co2_text
                                          ? _c(
                                              "div",
                                              {
                                                class:
                                                  _vm.vehicleStockData
                                                    .co2_text[0] === "-"
                                                    ? "text-danger"
                                                    : "text-success"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                " +
                                                    _vm._s(
                                                      _vm.vehicleStockData.co2_text.replace(
                                                        "-",
                                                        ""
                                                      )
                                                    ) +
                                                    "\n                                            "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.vehicleStockData.year) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.vehicleStockData.mileage) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "color" }, [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.vehicleStockData.color) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(
                                          _vm.vehicleStockData.engine_capacity
                                        ) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(
                                          _vm.vehicleStockData.transmission
                                        ) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.vehicleStockData.fuel_type) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.vehicleStockData.doors) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      "\n                                            " +
                                        _vm._s(_vm.vehicleStockData.condition) +
                                        "\n                                        "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.$userIsAdmin() ||
                                  _vm.vehicleStockData.is_public
                                    ? _c(
                                        "td",
                                        { staticClass: "blue" },
                                        [
                                          !_vm.hideStockPrice
                                            ? [
                                                _vm.vehicleStockData.user_id ===
                                                  null &&
                                                _vm.vehicleStockData
                                                  .user_region_price
                                                  ? [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.vehicleStockData
                                                              .user_region_price
                                                              .currency_sign
                                                          ) +
                                                          "\n                                                    " +
                                                          _vm._s(
                                                            _vm.numberWithCommas(
                                                              _vm
                                                                .vehicleStockData
                                                                .user_region_price
                                                                .pivot.price,
                                                              9999
                                                            )
                                                          ) +
                                                          "\n                                                    " +
                                                          _vm._s(
                                                            _vm.vehicleStockData
                                                              .user_region_price
                                                              .currency_code
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  : _vm.vehicleStockData
                                                      .sold_price
                                                  ? [
                                                      _vm.vehicleStockData
                                                        .currency === "NZD"
                                                        ? [_vm._v("$")]
                                                        : _vm._e(),
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.numberWithCommas(
                                                            _vm.vehicleStockData
                                                              .sold_price,
                                                            9999
                                                          )
                                                        ) +
                                                          "\n                                                    " +
                                                          _vm._s(
                                                            _vm.vehicleStockData
                                                              .currency
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ]
                                                  : _vm._e()
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ])
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col-md-6 mt-2" }, [
                              _vm.vehicleStockData.buy_now
                                ? _c(
                                    "div",
                                    { staticClass: "vehicle-banner now-sold" },
                                    [_vm._v("Now Sold")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.vehicleStockData.estimated_departure_date ||
                              _vm.vehicleStockData.estimated_arrival_date ||
                              _vm.vehicleStockData.ship ||
                              _vm.vehicleStockData.port
                                ? _c("div", [
                                    _c("strong", [_vm._v("ETD:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getDate(
                                            _vm.vehicleStockData
                                              .estimated_departure_date
                                          )
                                        ) +
                                        "     \n                                            "
                                    ),
                                    _c("strong", [_vm._v("ETA:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getDate(
                                            _vm.vehicleStockData
                                              .estimated_arrival_date
                                          )
                                        ) +
                                        "      \n                                            "
                                    ),
                                    _c("strong", [_vm._v("Ship:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.vehicleStockData.ship) +
                                        "     \n                                            "
                                    ),
                                    _c("strong", [_vm._v("Port:")]),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.vehicleStockData.port) +
                                        "\n                                        "
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _vm.vehicleStockData.user
                              ? _c(
                                  "div",
                                  { staticClass: "col-md-6 text-right mt-2" },
                                  [
                                    _vm.vehicleStockData.company_id ===
                                    _vm.loggedInUser.company_id
                                      ? [
                                          _vm._v(
                                            "\n                                            Your stock\n                                        "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                                            Stock of\n                                            "
                                          ),
                                          _c(
                                            "a",
                                            {
                                              attrs: {
                                                href: _vm.$laravelRoute(
                                                  "companies.show",
                                                  _vm.vehicleStockData
                                                    .company_id
                                                )
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                                " +
                                                  _vm._s(
                                                    _vm.vehicleStockData.user
                                                      .name
                                                  ) +
                                                  "\n                                                "
                                              ),
                                              _vm.vehicleStockData.company
                                                ? [
                                                    _vm._v(
                                                      "\n                                                    [ " +
                                                        _vm._s(
                                                          _vm.vehicleStockData
                                                            .company.name
                                                        ) +
                                                        " ]\n                                                "
                                                    )
                                                  ]
                                                : _vm._e()
                                            ],
                                            2
                                          )
                                        ]
                                  ],
                                  2
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _vm.vehicleStockData.messages
                            ? _c(
                                "div",
                                { staticClass: "all-bid" },
                                _vm._l(_vm.vehicleStockData.messages, function(
                                  msg,
                                  index
                                ) {
                                  return _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "bid history-bid",
                                        class:
                                          _vm.selectedMessage &&
                                          _vm.selectedMessage.id === msg.id
                                            ? "selected"
                                            : "",
                                        on: {
                                          click: function($event) {
                                            return _vm.selectMessage(msg)
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "cross item" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteMessage(
                                                      msg.id,
                                                      index
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("img", {
                                                  attrs: {
                                                    src: require("../../../images/cross.svg"),
                                                    alt: "Collapse"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "date item" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm.getDate(msg.created_at)
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "hour item" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(
                                                  _vm.getTime(msg.created_at)
                                                ) +
                                                "\n                                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "name item" },
                                          [
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(msg.user.name) +
                                                "\n                                            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "note item" },
                                          [
                                            msg.rep_only
                                              ? _c("strong", [
                                                  _vm._v("staff: ")
                                                ])
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                                                " +
                                                _vm._s(msg.message) +
                                                "\n                                            "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.vehicleStockData.is_public
                            ? _c("div", { staticClass: "history-buttons" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link add-message",
                                    on: {
                                      click: function($event) {
                                        return _vm.openMessageModal(false)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                                        Add Message\n                                    "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.$userIsAdmin()
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "link staff-message",
                                        on: {
                                          click: function($event) {
                                            return _vm.openMessageModal(true)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        Staff Message\n                                    "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ])
                            : _vm._e()
                        ]
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "container-fluid full-width" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-12" }, [
                    _c("div", { attrs: { id: "description-vehicle" } }, [
                      _c(
                        "div",
                        { staticClass: "description-vehicle" },
                        [
                          _c("translatable-text", {
                            attrs: {
                              text: _vm.vehicleStockData.description,
                              translate_now: true
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.vehicleStockData.equipment
                        ? _c("div", { staticClass: "equipment" }, [
                            _c("strong", [_vm._v("Equipment: ")]),
                            _vm._v(
                              _vm._s(_vm.vehicleStockData.equipment) +
                                "\n                            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.vehicleStockData.is_unsold &&
                      _vm.vehicleStockData.public_date &&
                      _vm.$userIsAdmin()
                        ? _c("div", { staticClass: "public_date" }, [
                            _c("strong", [_vm._v("Will be public on: ")]),
                            _vm._v(
                              _vm._s(_vm.vehicleStockData.public_date) +
                                " (" +
                                _vm._s(
                                  _vm.daysUntil(
                                    _vm.vehicleStockData.public_date
                                  )
                                ) +
                                ")\n                            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "notes" }, [
                        _c("strong", [_vm._v("Vehicle Notes: ")]),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.notes) }
                        })
                      ]),
                      _vm._v(" "),
                      _vm.$userIsAdmin()
                        ? _c("div", { staticClass: "notes" }, [
                            _c("strong", [_vm._v("Rep Notes: ")]),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.repNotes) }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.vehicleStockData.api_id && _vm.$userIsAdmin()
                        ? _c("div", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.$laravelRoute(
                                    "vehicle-detail",
                                    _vm.vehicleStockData.api_id
                                  )
                                }
                              },
                              [
                                _c("strong", [_vm._v("Auction Purchase")]),
                                _vm._v(" "),
                                _vm.vehicleStockData.auction_date
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.vehicleStockData.auction_date
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.vehicleStockData.auction_house
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.vehicleStockData.auction_house
                                        )
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.vehicleStockData.lot
                                  ? _c("span", [
                                      _vm._v(
                                        "#" + _vm._s(_vm.vehicleStockData.lot)
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { attrs: { id: "vehicle-image" } },
                        [
                          _c("VehicleStockImages", {
                            attrs: {
                              images: _vm.vehicleStockData.images,
                              extra: _vm.extraImages
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "col-12 d-flex justify-content-center mt-5"
                    },
                    [
                      _vm.showPurchase
                        ? [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "b-modal",
                                    rawName: "v-b-modal.modal-order",
                                    modifiers: { "modal-order": true }
                                  }
                                ],
                                staticClass: "mr-2"
                              },
                              [_vm._v("Buy Now")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.$userIsAdmin()
                        ? [
                            _c(
                              "a",
                              {
                                staticClass: "btn mr-2",
                                on: { click: _vm.openSendOfferModal }
                              },
                              [_vm._v("Send Offer")]
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.vehicleStockData.user_id === _vm.loggedInUser.id
                        ? _c(
                            "router-link",
                            {
                              staticClass: "btn",
                              attrs: {
                                to:
                                  "/claims/create?vehicle_id=" +
                                  _vm.vehicle_stock_id
                              }
                            },
                            [_vm._v("Make a Claim")]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "container-fluid full-width" },
                [
                  _c(
                    "b-modal",
                    {
                      attrs: { id: "modal-order", centered: "", size: "lg" },
                      scopedSlots: _vm._u([
                        {
                          key: "modal-header",
                          fn: function(ref) {
                            var close = ref.close
                            return [
                              _c("img", {
                                attrs: {
                                  src: require("./../../../images/sbl-logo-blue.png"),
                                  alt: "Sbl Logo",
                                  width: "250px"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "close",
                                  attrs: {
                                    type: "button",
                                    "aria-label": "Close"
                                  },
                                  on: {
                                    click: function($event) {
                                      return close()
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        xmlns: "http://www.w3.org/2000/svg",
                                        viewBox: "0 0 384 512"
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          stroke: "#B7B7B7",
                                          d:
                                            "M338.1 413.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 256 349.4 109.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 244.7 45.9 98.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 34.6 402.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 267.3 338.1 413.4z"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          }
                        },
                        {
                          key: "modal-footer",
                          fn: function(ref) {
                            var ok = ref.ok
                            var cancel = ref.cancel
                            var hide = ref.hide
                            return [
                              _c(
                                "div",
                                { staticClass: "buttons" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { size: "sm", variant: "danger" },
                                      on: {
                                        click: function($event) {
                                          return cancel()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                Cancel\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        type: "submit",
                                        size: "sm",
                                        variant: "success"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.sendOrder()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                                Buy Now\n                            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("small", { staticClass: "mt-3" }, [
                                _vm._v(
                                  "\n                            *Please Note: This price does not include the $225 BMSB Heat Treatment surcharge.\n                            MPI has determined that the BMSB season runs from September 1st until April 30th,\n                            however this is subject to change at any time by MPI.\n                            Should Heat Treatment be required for this vehicle, the related BMSB Heat Treatment\n                            charge will be applied at the time of final invoice.\n                        "
                                )
                              ])
                            ]
                          }
                        }
                      ])
                    },
                    [
                      _vm._v(" "),
                      _c("h5", [_vm._v("Confirmation of Vehicle Purchase")]),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          on: {
                            submit: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c("messages", { attrs: { messages: _vm.messages } }),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12" },
                              [
                                _vm._v(
                                  "\n                                By clicking the "
                                ),
                                _c(
                                  "strong",
                                  { staticStyle: { color: "#0488DF" } },
                                  [_vm._v("Buy Now")]
                                ),
                                _vm._v(
                                  " button you are agreeing to purchase the following "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _vm.vehicleStockData.stock_id
                                  ? _c(
                                      "strong",
                                      { staticStyle: { color: "#0488DF" } },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.vehicleStockData.stock_id
                                            ) +
                                            ",\n                                "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "strong",
                                      { staticStyle: { color: "#0488DF" } },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.vehicleStockData
                                                .green_tree_sync_id
                                            ) +
                                            ",\n                                "
                                        )
                                      ]
                                    ),
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.vehicleStockData.year) +
                                    ",\n                                " +
                                    _vm._s(_vm.vehicleStockData.make) +
                                    ",\n                                " +
                                    _vm._s(_vm.vehicleStockData.model) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _vm.vehicleStockData.user_id === null &&
                                _vm.vehicleStockData.user_region_price
                                  ? [
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#0488DF" } },
                                        [_vm._v("Price")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "strong",
                                        { staticStyle: { color: "#C69200" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.vehicleStockData
                                                .user_region_price.currency_sign
                                            ) +
                                              _vm._s(
                                                _vm.numberWithCommas(
                                                  _vm.vehicleStockData
                                                    .user_region_price.pivot
                                                    .price
                                                )
                                              ) +
                                              "\n                                    " +
                                              _vm._s(
                                                _vm.vehicleStockData
                                                  .user_region_price
                                                  .currency_code
                                              ) +
                                              "* un-complied + local delivery"
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          ]),
                          _vm._v(" "),
                          _vm.vehicleStockData.no_claims_accepted
                            ? [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-12" }, [
                                    _c("br"),
                                    _c("br"),
                                    _vm._v(
                                      "\n                                    You also acknowledge and agree to the following"
                                    ),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _c("ul", [
                                      _c("li", [
                                        _vm._v(
                                          "\n                                            You understand that no claims can be made on this vehicle due to the reason outlined below.\n                                            "
                                        ),
                                        _c("br"),
                                        _c(
                                          "strong",
                                          { staticStyle: { color: "#2F6EBA" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.vehicleStockData
                                                  .no_claims_accepted
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ])
                                ])
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "mt-4 acceptance" },
                              [
                                _vm.vehicleStockData.no_claims_accepted
                                  ? _c(
                                      "b-form-group",
                                      {
                                        staticClass: "mb-2",
                                        attrs: {
                                          id: "input-group-2",
                                          label: "",
                                          "label-for":
                                            "no_claims_user_confirmed",
                                          "invalid-feedback": _vm.invalidField(
                                            "no_claims_user_confirmed"
                                          )
                                        }
                                      },
                                      [
                                        _c(
                                          "b-form-checkbox",
                                          {
                                            attrs: {
                                              id: "no_claims_user_confirmed",
                                              state: _vm.fieldState(
                                                "no_claims_user_confirmed"
                                              ),
                                              required: ""
                                            },
                                            model: {
                                              value:
                                                _vm.order
                                                  .no_claims_user_confirmed,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.order,
                                                  "no_claims_user_confirmed",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "order.no_claims_user_confirmed"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        I accept full responsibility for the vehicle and release SBL from any liability for current or future issues related to reason above.\n                                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      id: "input-group-2",
                                      label: "",
                                      "label-for": "order_confirm",
                                      "invalid-feedback": _vm.invalidField(
                                        "confirm"
                                      )
                                    }
                                  },
                                  [
                                    _c(
                                      "b-form-checkbox",
                                      {
                                        attrs: {
                                          id: "order_confirm",
                                          state: _vm.fieldState("confirm"),
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.order.confirm,
                                          callback: function($$v) {
                                            _vm.$set(_vm.order, "confirm", $$v)
                                          },
                                          expression: "order.confirm"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        I accept the "
                                        ),
                                        _c("strong", [_vm._v("Buy Now")]),
                                        _vm._v(" price and agree to complete"),
                                        _c("br"),
                                        _vm._v(
                                          " the purchase according to the SBL terms and conditions.\n                                    "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        2
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("VehicleStockMessage", {
                ref: "message",
                on: { changed: _vm.onAddMessage }
              }),
              _vm._v(" "),
              _c("vehicle-send-offer-modal", {
                attrs: {
                  vehicle: _vm.vehicleStockData,
                  vehicle_id: _vm.vehicleStockData.id
                },
                model: {
                  value: _vm.sendOfferModalOpen,
                  callback: function($$v) {
                    _vm.sendOfferModalOpen = $$v
                  },
                  expression: "sendOfferModalOpen"
                }
              }),
              _vm._v(" "),
              _c("EmissionModal", {
                attrs: {
                  show: _vm.showEmissionModal,
                  emission: _vm.selectedEmission
                },
                on: {
                  close: function($event) {
                    _vm.showEmissionModal = false
                  }
                }
              })
            ],
            1
          )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid full-width" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _vm._v(" Vehicle not found. ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid full-width" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" })
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-188ece96", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188ece96","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/ShowPage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-188ece96","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/VehicleStock/ShowPage.vue
// module chunks = 0